module.exports = __webpack_public_path__ + "static/media/userLocation.236c5ad3.png";